import React, { useEffect, useState } from 'react'
import { useUser } from 'util/UserContext'
import { useNavigate, useParams } from 'react-router-dom'
import UserSettingsAccount from './UserSettingsAccount'
import UserSettingsProfile from './UserSettingsProfile'
import UserSettingsPrivacy from './UserSettingsPrivacy'
import ScrollableTabsList from 'ui/ScrollableTabsList'

const UserSettings: React.FC = () => {
    const { currentUser, awaitingUser } = useUser()
    const navigate = useNavigate()
    const { tab } = useParams<{ tab: string }>()
    const [selectedTab, setSelectedTab] = useState<string>(tab || 'profile')

    // Redirect if not logged in
    useEffect(() => {
        if (!awaitingUser && !currentUser) {
            navigate('/', { replace: true })
        }
    }, [currentUser, awaitingUser, navigate])

    // Update selectedTab when URL tab parameter changes
    useEffect(() => {
        if (tab) {
            setSelectedTab(tab)
        } else {
            setSelectedTab('profile')
        }
    }, [tab])

    //REMOVED: already have NavLink on scrollable tabs so this causes double navigation
    /*const handleTabChange = (newTab: string) => {
        setSelectedTab(newTab)
        navigate(`/settings/${newTab}`)
    }*/

    const tabsData = [
        {
            label: 'Profile',
            route: '/settings/profile',
            value: 'profile',
        },
        {
            label: 'Privacy',
            route: '/settings/privacy',
            value: 'privacy',
        },
        {
            label: 'Account',
            route: '/settings/account',
            value: 'account',
        },
        /*{
            label: 'Preferences',
            route: '/settings/preferences',
            value: 'preferences',
        },*/
        {
            label: 'Notifications',
            route: '/settings/notifications',
            value: 'notifications',
        },
    ]

    return (
        <div className="max-w-4xl m-4">
            <h1 className="my-2 text-eoe-text-heading dark:text-eoe-dark-text-heading text-xl font-bold">
                Settings
            </h1>
            
            {/* Tabs Navigation */}
            <div className="horizontal-tablist my-2">
                <ScrollableTabsList
                    key="settings-tabs"
                    tabs={tabsData}
                    selectedTab={selectedTab}
                    onTabChange={() => {}}
                    pageTitle="Settings"
                />
            </div>

            {/* Tabs Content */}
            <div className="">
                {selectedTab === 'account' && (
                    <div
                        role="tabpanel"
                        id="account-panel"
                        aria-labelledby="account-tab"
                        className="focus:outline-none"
                    >
                        <UserSettingsAccount />
                    </div>
                )}
                {selectedTab === 'profile' && (
                    <div
                        role="tabpanel"
                        id="profile-panel"
                        aria-labelledby="profile-tab"
                        className="focus:outline-none"
                    >
                        <UserSettingsProfile />
                    </div>
                )}
                {selectedTab === 'privacy' && (
                    <div
                        role="tabpanel"
                        id="privacy-panel"
                        aria-labelledby="privacy-tab"
                        className="focus:outline-none"
                    >
                        <UserSettingsPrivacy />
                    </div>
                )}
                {selectedTab === 'notifications' && (
                    <div
                        role="tabpanel"
                        id="notifications-panel"
                        aria-labelledby="notifications-tab"
                        className="focus:outline-none"
                    >
                        Coming soon
                    </div>
                )}
            </div>
        </div>
    )
}

export default UserSettings